import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { InputControlBase } from './../forms/input-control.base';
import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

/**
 * @astral-compatible Retained for integer-only validation and existing form contracts.
 * Its renderer is already Astralized; do not replace it unless that validation is preserved.
 */
@Component({
    selector: 'app-int-box',
    templateUrl: './int-box.component.html',
    styleUrls: ['./int-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IntBoxComponent extends InputControlBase {
  constructor() {
    super();
  }

  private validator(control: AbstractControl): ValidationErrors {
    if (!control.value) {
      return null;
    }

    return Validators.pattern(/^\d+\s*$/);
  }

  ngOnInit() {
    super.ngOnInit();

    if (!this.control) {
      throw new Error('A control model must be specified.');
    }
    if (this.control.validator) this.control.setValidators([this.control.validator, this.validator]);
    else this.control.setValidators(this.validator);
  }
}
